import axios from "axios";
import { logout } from "../lib/auth";

import {
  dataDifine,
  EditDataDifine,
  DataColumn,
} from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

//  トスアップ一覧取得
export async function getTossUps(
  props: { [key: string]: number | string },
  sortColumn: {
    key: string;
    sort: string;
  }[],
  screenColumn: DataColumn[],
) {
  try {
    const path = "tossUps";
    const params = makeParams(screenColumn, props);
    const response = await axios.get(CONST.apiUrl + path, {
      params: { ...params, sortColumn },
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const tossUps: dataDifine[] = response.data.fetch_data;
    const countTossUps: string = response.data.count_data;
    return { tossUps, countTossUps };
  } catch (error) {
    // logout();
  }
}

// トスアップ詳細取得
export async function getTossUp(id: string) {
  try {
    const path = "tossUp";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const detail_data: {
      [key: string]: number | string | { [key: string]: string | string[] };
    } = response.data.detail_data[0];
    const option_data: {
      [key: string]: string | number;
    }[] = response.data.option_data;
    const contract_history: {
      selected_date: string;
      contract_version: number;
    }[] = response.data.contract_history;
    return { detail_data, option_data, contract_history };
  } catch (error) {
    // logout();
    return { detail_data: {}, option_data: [], contract_history: [] };
  }
}

export async function postTossUp(addData: {
  addStatus:
    | null
    | "loading"
    | "change_account"
    | "product"
    | "toss_up"
    | "success"
    | "failed";
  category_id_list: number[];
  product_name_list: string[];
  phone_number: string;
  customer_name: string;
  customer_list_id: string;
  customerInfo: { [key: string]: string | string[] };
  changeAccount: 0 | 1;
  changeAccountID: number | null;
}) {
  try {
    const path = "tossUp";
    const bodys = addData;
    const response = await axios.post(CONST.apiCognitoUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// トスアップ情報編集
export async function putTossUp(editData: EditDataDifine) {
  try {
    const path = "tossUp";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
      editPhoneNumber: editData.editPhoneNumber,
      editName: editData.editName,
      tel_flg: editData.tel_flg,
      name_flg: editData.name_flg,
      half_width_number_flg: editData.half_width_number_flg,
      editType: editData.editType,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// トスアップ無効化
export async function deleteTossUp(id: string) {
  try {
    const path = "tossUp";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}

// トスアップ前のカテゴリ・商材選択用
export async function getTossUpAddBefore(
  changeAccount: 0 | 1,
  changeAccountID: number | null,
) {
  try {
    const path = "tossUp/add/before";
    const params = { changeAccount, changeAccountID };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    return {
      tossUpCategoryNameList: (response.data.tossUpCategoryNameList ?? []) as {
        category_id: number;
        category_name: string;
      }[],
      tossUpProductNameList: (response.data.tossUpProductNameList ?? []) as {
        category_id: number;
        category_name: string;
        product_name: string;
      }[],
    };
  } catch (error) {
    // logout();
    return { tossUpCategoryNameList: [], tossUpProductNameList: [] };
  }
}

// トスアップ前のトスアップフォーム取得用
export async function getTossUpAddForm(
  category_id_list: number[],
  product_name_list: string[],
  changeAccount: 0 | 1,
  changeAccountID: number | null,
) {
  try {
    const path = "tossUp/add/form";
    const params = {
      category_id_list,
      product_name_list,
      changeAccount,
      changeAccountID,
    };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const option_data: {
      [key: string]: string | number;
    }[] = response.data.option_data;
    return {
      option_data,
    };
  } catch (error) {
    // logout();
    return { option_data: [] };
  }
}

// クロージング前のトスアップ情報、商材選択用情報取得
export async function getTossUpClosingBefore(
  id: string,
  changeAccount: 0 | 1,
  changeAccountID: number | null,
) {
  try {
    const path = "tossUp/closing/before";
    const params = { id, changeAccount, changeAccountID };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.conflict) {
      return { conflict: true, toss_up_data: {}, product_data: [], detail_data: {}, option_data: [] };
    }
    const toss_up_data: {
      [key: string]: string | number | { [key: string]: string | string[] };
    } = response.data.toss_up_data[0];
    const product_data: {
      id: number;
      product_id: number;
      product_name: string;
      have_entry_form: number;
      site_path_list: string[];
    }[] = response.data.fetch_data;
    const detail_data: {
      [key: string]: number | string | { [key: string]: string | string[] };
    } = response.data.detail_data[0];
    const option_data: {
      [key: string]: string | number;
    }[] = response.data.option_data;
    return { conflict: false, toss_up_data, product_data, detail_data, option_data };
  } catch (error) {
    // logout();
    return {
      conflict: false,
      toss_up_data: {},
      product_data: [],
      detail_data: {},
      option_data: [],
    };
  }
}

// クロージング処理 - 失敗・不出・折り返し
export async function putTossUpClosingFailed(
  id: string,
  toss_up_status: number,
  closing_memo: string,
  closing_failed_memo: string,
  hope_call_date: string,
  hope_call_time_kind: number | null,
  hope_call_time: string,
  return_call_memo: string,
  changeAccount: 0 | 1,
  changeAccountID: number | null,
) {
  try {
    const path = "tossUp/closing/failed";
    const params = { id };
    const bodys = {
      id,
      toss_up_status,
      closing_memo,
      closing_failed_memo,
      hope_call_date,
      hope_call_time_kind,
      hope_call_time,
      return_call_memo,
      changeAccount,
      changeAccountID,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
    return "failed";
  }
}

// クロージング処理 - キャンセル
export async function putTossUpClosingCancell(id: string) {
  try {
    const path = "tossUp/closing/cancell";
    const params = { id };
    const bodys = { id };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
    return "failed";
  }
}

// トスアップ処理 - 成功 - エントリーフォーム取得
export async function getTossUpClosingForm(
  id: number,
  toss_up_id: string,
  outSiteEntry: 0 | 1,
  site_path: string,
  changeAccount: 0 | 1,
  changeAccountID: number | null,
) {
  try {
    const path = "tossUp/closing/form";
    const params = {
      id,
      toss_up_id,
      outSiteEntry,
      site_path,
      changeAccount,
      changeAccountID,
    };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    // 内部エントリー用のデータ
    const service_plan_data: { service_name: string }[] =
      response.data.service_plan_data;
    const service_content_data: { service_name: string }[] =
      response.data.service_content_data;
    const service_campaign_pulldown_data: { service_name: string }[] =
      response.data.service_campaign_pulldown_data;
    const service_campaign_checkbox_data: { service_name: string }[] =
      response.data.service_campaign_checkbox_data;
    const service_payment_data: { payment_method: string }[] =
      response.data.service_payment_data;
    const option_data: {
      [key: string]: string | number | string[];
    }[] = response.data.option_data;
    const toss_up_option_data: {
      [key: string]: string | number | string[];
    }[] = response.data.toss_up_option_data;

    // 外部エントリー用のデータ
    const outside_pull_down_service: { service_name: string }[] =
      response.data.outside_pull_down_service;
    const outside_check_box_service: { service_name: string }[] =
      response.data.outside_check_box_service;
    const outside_option_data: {
      [key: string]: string | number | string[];
    }[] = response.data.outside_option_data;
    const outside_sms_patterns: {
      id: number;
      outside_sms_name: string;
      outside_sms_sender: string;
      outside_sms_body: string;
    }[] = response.data.outside_sms_patterns;
    const outside_mail_patterns: {
      id: number;
      outside_sms_name: string;
      outside_sms_sender: string;
      outside_sms_title: string;
      outside_sms_body: string;
    }[] = response.data.outside_mail_patterns;

    return {
      service_plan_data,
      service_content_data,
      service_campaign_pulldown_data,
      service_campaign_checkbox_data,
      service_payment_data,
      option_data,
      toss_up_option_data,
      outside_pull_down_service,
      outside_check_box_service,
      outside_option_data,
      outside_sms_patterns,
      outside_mail_patterns,
    };
  } catch (error) {
    // logout();
    return {
      service_plan_data: [],
      service_content_data: [],
      service_campaign_pulldown_data: [],
      service_campaign_checkbox_data: [],
      service_payment_data: [],
      option_data: [],
      toss_up_option_data: [],
      outside_pull_down_service: [],
      outside_check_box_service: [],
      outside_option_data: [],
      outside_sms_patterns: [],
      outside_mail_patterns: [],
    };
  }
}

// トスアップデータ複製前の事前情報取得用
export async function getTossUpCopyBefore(
  toss_up_id: string,
  changeAccount: 0 | 1,
  changeAccountID: number | null,
) {
  try {
    const path = "tossUp/copy/before";
    const params = { toss_up_id, changeAccount, changeAccountID };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    return {
      tossUpCategoryNameList: response.data.tossUpCategoryNameList as {
        category_id: number;
        category_name: string;
      }[],
      tossUpProductNameList: response.data.tossUpProductNameList as {
        category_id: number;
        category_name: string;
        product_name: string;
      }[],
      toss_up_data: response.data.toss_up_data[0] as {
        [key: string]: string | number | { [key: string]: string | string[] };
      },
    };
  } catch (error) {
    // logout();
    return {
      tossUpCategoryNameList: [],
      tossUpProductNameList: [],
      toss_up_data: {},
    };
  }
}

// トスアップデータ複製前のトスアップフォーム取得用
export async function getTossUpCopyAddForm(
  toss_up_id: string,
  category_id_list: number[],
  product_name_list: string[],
  changeAccount: 0 | 1,
  changeAccountID: number | null,
) {
  try {
    const path = "tossUp/copy/form";
    const params = {
      toss_up_id,
      category_id_list,
      product_name_list,
      changeAccount,
      changeAccountID,
    };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const option_data: {
      [key: string]: string | number | string[];
    }[] = response.data.option_data;
    const before_option_data: {
      [key: string]: string | number;
    }[] = response.data.before_option_data;
    return {
      option_data,
      before_option_data,
    };
  } catch (error) {
    // logout();
    return { option_data: [], before_option_data: [] };
  }
}

// トスアップ編集前の商材・カテゴリー一覧取得
export async function getTossUpEditBefore(id: string) {
  try {
    const path = "tossUp/edit/before";
    const params = {
      id,
    };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const tossUpCategoryNameList: {
      category_id: number;
      category_name: string;
    }[] = response.data.tossUpCategoryNameList;
    const tossUpProductNameList: {
      category_id: number;
      category_name: string;
      product_name: string;
    }[] = response.data.tossUpProductNameList;
    const category_id_list: string[] = response.data.category_id_list;
    const product_name_list: string[] = response.data.product_name_list;
    return {
      tossUpCategoryNameList,
      tossUpProductNameList,
      category_id_list,
      product_name_list,
    };
  } catch (error) {
    // logout();
    return {
      tossUpCategoryNameList: [],
      tossUpProductNameList: [],
      category_id_list: [],
      product_name_list: [],
    };
  }
}
